module.exports = __webpack_public_path__ + "static/media/node.fe06125f.png";